export default {
  title: 'Controlo de acesso: {{role}}',
  form: {
    companies: {
      label: 'Visível para todos os membros com a função {{role}}',
      tooltip: 'Isto será adicionado aos locais onde o membro da equipa se registou',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados, por favor atualize a página',
    failed_to_save_changes: 'Falha ao guardar alterações',
    changes_got_saved: 'Alterações guardadas',
  },
};
